const USDOption = { style: "currency", currency: "USD" };
const formatter = new Intl.NumberFormat("en-US", USDOption);

export default amount => formatter.format(amount ?? 0);
